import * as React from "react";

function SvgTune(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 716 180"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="TUNE_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={452}
        y1={180}
        x2={452}
        y2={0}
      >
        <stop offset={0} stopColor="#005aff" />
        <stop offset={1} stopColor="#08f" />
      </linearGradient>
      <path
        fill="url(#TUNE_svg__a)"
        d="M528 76c0-41.9-34.1-76-76-76s-76 34.1-76 76v99c0 2.8 2.2 5 5 5h26c2.8 0 5-2.2 5-5V76c0-22.1 17.9-40 40-40s40 17.9 40 40v99c0 2.8 2.2 5 5 5h26c2.8 0 5-2.2 5-5V76z"
      />
      <linearGradient
        id="TUNE_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={76}
        y1={180}
        x2={76}
        y2={0}
      >
        <stop offset={0} stopColor="#005aff" />
        <stop offset={1} stopColor="#08f" />
      </linearGradient>
      <path
        fill="url(#TUNE_svg__b)"
        d="M0 5v26c0 2.8 2.2 5 5 5h48c2.8 0 5 2.2 5 5v134c0 2.8 2.2 5 5 5h26c2.8 0 5-2.2 5-5V41c0-2.8 2.2-5 5-5h48c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5H5C2.2 0 0 2.2 0 5z"
      />
      <linearGradient
        id="TUNE_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={264}
        y1={180}
        x2={264}
        y2={0}
      >
        <stop offset={0} stopColor="#005aff" />
        <stop offset={1} stopColor="#08f" />
      </linearGradient>
      <path
        fill="url(#TUNE_svg__c)"
        d="M188 104c0 41.9 34.1 76 76 76s76-34.1 76-76V5c0-2.8-2.2-5-5-5h-26c-2.8 0-5 2.2-5 5v99c0 22.1-17.9 40-40 40s-40-17.9-40-40V5c0-2.8-2.2-5-5-5h-26c-2.8 0-5 2.2-5 5v99z"
      />
      <linearGradient
        id="TUNE_svg__d"
        gradientUnits="userSpaceOnUse"
        x1={640}
        y1={180}
        x2={640}
        y2={0}
      >
        <stop offset={0} stopColor="#005aff" />
        <stop offset={1} stopColor="#08f" />
      </linearGradient>
      <path
        fill="url(#TUNE_svg__d)"
        d="M640 36h71c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5h-72c-41.5.5-75 34.3-75 76v28c0 41.6 33.5 75.4 75 76h72c2.8 0 5-2.2 5-5v-26c0-2.8-2.2-5-5-5h-71c-18.6 0-34.2-12.6-38.7-29.8-.8-3.1 1.6-6.2 4.9-6.2H711c2.8 0 5-2.2 5-5V77c0-2.8-2.2-5-5-5H606.2c-3.3 0-5.7-3.1-4.9-6.2C605.8 48.6 621.5 36 640 36z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgTune);
